import { injectWithSelf } from '@/utils/injectWithSelf'
import { computed, inject, InjectionKey, provide, ref, Ref, unref } from 'vue'

type ParentRouteNameContextType = {
  parentRouteName: Ref<string | null | undefined>
}
const ParentRouteNameContextKey: InjectionKey<ParentRouteNameContextType> =
  Symbol('ParentRouteNameContext')

type MaybeRef<T> = Ref<T> | T

export const useParentRouteNameProvider = (
  parentRouteName: MaybeRef<string | null | undefined>,
) => {
  // If already provided, don't provide again
  const existing = inject(ParentRouteNameContextKey, null)
  if (existing) {
    return
  }
  const _parentRouteName = computed(() => unref(parentRouteName))
  provide(ParentRouteNameContextKey, { parentRouteName: _parentRouteName })
}

export const useParentRouteName = () => {
  const { parentRouteName } = injectWithSelf(ParentRouteNameContextKey, () => ({
    parentRouteName: ref(''),
  }))

  return { parentRouteName }
}
